import StickyHeader from './sticky-header'

export default StickyHeader
